import React from "react";
import { BillingInterval } from "shared/enums/BillingIntervalEnum";
import { Currency } from "shared/enums/CurrencyEnum";
import { getCurrencySymbol, isNumber } from "shared/utility/CommonUtility";
import { getFormattedNumber } from "shared/utility/NumberUtility";
import BillingIntervalDisplay from "./BillingIntervalDisplay";

interface Props {
  currency?: Currency;
  actions: number;
  price: number;
  tag: string;
  isAutomaticPurchaseAllowed: boolean;
  billingInterval: BillingInterval;
  isActive?: boolean;
  isDisabled?: boolean;
  onClick?: () => void;
}

export default function PlanCard(props: Props) {
  const {
    currency,
    isActive,
    actions,
    price,
    tag,
    isAutomaticPurchaseAllowed,
    billingInterval,
    isDisabled,
    onClick,
  } = props;

  const handleOnClick = () => {
    if (!isDisabled && onClick) {
      onClick();
    }
  };

  const getPricingDisplay = (price: string, tag: string | React.ReactNode) => {
    return (
      <>
        <div className="text-sm mt-7px">
          {isNumber(price)
            ? `${getCurrencySymbol(currency!)} ${getFormattedNumber(
                Number(price)
              )}`
            : price}
        </div>
        <div className={`text-2xs ${isActive ? "" : "text-promGray2"}`}>
          {tag}
        </div>
      </>
    );
  };

  const PricingInformation = () => {
    if (!price && isAutomaticPurchaseAllowed) {
      return getPricingDisplay("free", "always");
    }

    if (!isAutomaticPurchaseAllowed) {
      return getPricingDisplay("custom", "pricing");
    }

    return getPricingDisplay(
      price.toString(),
      <BillingIntervalDisplay billingInterval={billingInterval} />
    );
  };

  const ActionInformation = () => {
    return (
      <>
        <div
          className={`font-bold ${
            isActive && !isDisabled ? "text-primaryRed" : ""
          }`}
        >
          {isAutomaticPurchaseAllowed
            ? getFormattedNumber(actions)
            : "enterprise"}
        </div>
        <div
          className={`font-medium text-xs ${isActive ? "" : "text-promGray2"}`}
        >
          {tag}
        </div>
      </>
    );
  };

  return (
    <div
      className={`rounded-lg border p-2 w-full h-25 ${
        isDisabled ? "text-promGray2" : "cursor-pointer hover:bg-promWhite1"
      } ${
        isActive
          ? "border-primaryRed bg-promWhite1"
          : `${!isDisabled ? "shadow-customLarge" : ""} border-silver`
      }`}
      onClick={handleOnClick}
    >
      <div className="flex items-center justify-center flex-col">
        <ActionInformation />
        <PricingInformation />
      </div>
    </div>
  );
}

PlanCard.defaultProps = {
  isActive: false,
  currency: Currency.EUR,
};
